(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8509],{

/***/ 74097:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Generated by ReScript, PLEASE EDIT WITH CARE


var Antd = __webpack_require__(17072);
var React = __webpack_require__(67294);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);

var _map = {"button":"button","checkobx":"checkobx","color":"color","date":"date","datetimeLocal":"datetime-local","email":"email","file":"file","hidden":"hidden","image":"image","month":"month","number":"number","password":"password","radio":"radio","range":"range","reset":"reset","search":"search","submit":"submit","tel":"tel","text":"text","time":"time","url":"url","week":"week"};

var _revMap = {"button":"button","checkobx":"checkobx","color":"color","date":"date","datetime-local":"datetimeLocal","email":"email","file":"file","hidden":"hidden","image":"image","month":"month","number":"number","password":"password","radio":"radio","range":"range","reset":"reset","search":"search","submit":"submit","tel":"tel","text":"text","time":"time","url":"url","week":"week"};

function inputTypeToJs(param) {
  return _map[param];
}

function inputTypeFromJs(param) {
  return _revMap[param];
}

var Internal = {};

function Antd_Input(Props) {
  var autoFocus = Props.autoFocus;
  var placeholder = Props.placeholder;
  var addonAfter = Props.addonAfter;
  var addonBefore = Props.addonBefore;
  var defaultValue = Props.defaultValue;
  var disabled = Props.disabled;
  var id = Props.id;
  var prefix = Props.prefix;
  var size = Props.size;
  var suffix = Props.suffix;
  var value = Props.value;
  var onChange = Props.onChange;
  var onFocus = Props.onFocus;
  var onPressEnter = Props.onPressEnter;
  var onBlur = Props.onBlur;
  var onClick = Props.onClick;
  var onDoubleClick = Props.onDoubleClick;
  var onKeyDown = Props.onKeyDown;
  var _type = Props.type;
  var readOnly = Props.readOnly;
  var autoComplete = Props.autoComplete;
  var allowClear = Props.allowClear;
  var status = Props.status;
  var className = Props.className;
  var style = Props.style;
  var children = Props.children;
  var tmp = {
    children: children !== undefined ? Caml_option.valFromOption(children) : null
  };
  if (autoFocus !== undefined) {
    tmp.autoFocus = autoFocus;
  }
  if (placeholder !== undefined) {
    tmp.placeholder = placeholder;
  }
  if (addonAfter !== undefined) {
    tmp.addonAfter = Caml_option.valFromOption(addonAfter);
  }
  if (addonBefore !== undefined) {
    tmp.addonBefore = Caml_option.valFromOption(addonBefore);
  }
  if (defaultValue !== undefined) {
    tmp.defaultValue = defaultValue;
  }
  if (disabled !== undefined) {
    tmp.disabled = disabled;
  }
  if (id !== undefined) {
    tmp.id = id;
  }
  if (prefix !== undefined) {
    tmp.prefix = Caml_option.valFromOption(prefix);
  }
  if (size !== undefined) {
    tmp.size = Caml_option.valFromOption(size);
  }
  if (suffix !== undefined) {
    tmp.suffix = Caml_option.valFromOption(suffix);
  }
  if (value !== undefined) {
    tmp.value = value;
  }
  if (onChange !== undefined) {
    tmp.onChange = Caml_option.valFromOption(onChange);
  }
  if (onFocus !== undefined) {
    tmp.onFocus = Caml_option.valFromOption(onFocus);
  }
  if (onPressEnter !== undefined) {
    tmp.onPressEnter = Caml_option.valFromOption(onPressEnter);
  }
  if (onBlur !== undefined) {
    tmp.onBlur = Caml_option.valFromOption(onBlur);
  }
  if (onClick !== undefined) {
    tmp.onClick = Caml_option.valFromOption(onClick);
  }
  if (onDoubleClick !== undefined) {
    tmp.onDoubleClick = Caml_option.valFromOption(onDoubleClick);
  }
  if (onKeyDown !== undefined) {
    tmp.onKeyDown = Caml_option.valFromOption(onKeyDown);
  }
  var tmp$1 = Belt_Option.map(_type, inputTypeToJs);
  if (tmp$1 !== undefined) {
    tmp.type = tmp$1;
  }
  if (readOnly !== undefined) {
    tmp.readOnly = readOnly;
  }
  if (autoComplete !== undefined) {
    tmp.autoComplete = autoComplete;
  }
  if (allowClear !== undefined) {
    tmp.allowClear = allowClear;
  }
  if (status !== undefined) {
    tmp.status = Caml_option.valFromOption(status);
  }
  if (className !== undefined) {
    tmp.className = className;
  }
  if (style !== undefined) {
    tmp.style = Caml_option.valFromOption(style);
  }
  return React.createElement(Antd.Input, tmp);
}

function bool(v) {
  return v;
}

function minAndMaxRows(v) {
  return v;
}

var AutoSize = {
  bool: bool,
  minAndMaxRows: minAndMaxRows
};

var TextArea = {
  AutoSize: AutoSize
};

var Search = {};

var Group = {};

var Password = {};

var make = Antd_Input;

exports.inputTypeToJs = inputTypeToJs;
exports.inputTypeFromJs = inputTypeFromJs;
exports.Internal = Internal;
exports.make = make;
exports.TextArea = TextArea;
exports.Search = Search;
exports.Group = Group;
exports.Password = Password;
/* antd Not a pure module */


/***/ }),

/***/ 57982:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forgot_password",
      function () {
        return __webpack_require__(74176);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 74176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _src_common_PageForgotPassword_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50622);

/* harmony default export */ __webpack_exports__["default"] = (_src_common_PageForgotPassword_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .make */ .S);


/***/ }),

/***/ 50622:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
// Generated by ReScript, PLEASE EDIT WITH CARE

var Css = __webpack_require__(62418);
var Antd = __webpack_require__(17072);
var Curry = __webpack_require__(41386);
var Fetch = __webpack_require__(84403);
var React = __webpack_require__(67294);
var Head = (__webpack_require__(9008)["default"]);
var Antd_Input = __webpack_require__(74097);
var Caml_option = __webpack_require__(57175);
var Json_encode = __webpack_require__(82065);
var Router = __webpack_require__(11163);
var Segment$SmartcutsMacros = __webpack_require__(60545);
var ReactUtils$SmartcutsMacros = __webpack_require__(80310);
var LayoutPublic$SmartcutsMacros = __webpack_require__(64056);
var PromiseUtils$SmartcutsMacros = __webpack_require__(57019);
function requestForgotPassword(email) {
    Segment$SmartcutsMacros.trackUserForgotPassword(undefined);
    return fetch("/api/forgot_password", Fetch.RequestInit.make(/* Post */ 2, {
        "Content-Type": "application/json"
    }, Caml_option.some(JSON.stringify(Json_encode.object_({
        hd: [
            "email",
            email
        ],
        tl: /* [] */ 0
    }))), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined));
}
function PageForgotPassword(Props) {
    var router = Router.useRouter();
    var match = React.useState(function() {
        return {
            email: "",
            isRequestingForgotPassword: false
        };
    });
    var setState = match[1];
    var match$1 = match[0];
    var email = match$1.email;
    return React.createElement(LayoutPublic$SmartcutsMacros.make, {
        onClickCallToAction: function(param) {
            router.push("/", undefined, undefined);
        },
        children: null
    }, React.createElement(Head, {
        children: React.createElement("title", undefined, ReactUtils$SmartcutsMacros.s("Forgot Password"))
    }), React.createElement("section", {
        className: Curry._1(Css.style, {
            hd: Css.maxWidth({
                NAME: "px",
                VAL: 720
            }),
            tl: {
                hd: Css.selector("& > *", {
                    hd: Css.margin2({
                        NAME: "px",
                        VAL: 30
                    }, "zero"),
                    tl: /* [] */ 0
                }),
                tl: {
                    hd: Css.selector("h2", {
                        hd: Css.textAlign("center"),
                        tl: /* [] */ 0
                    }),
                    tl: {
                        hd: Css.selector("form", {
                            hd: Css.display("flex"),
                            tl: {
                                hd: Css.flexDirection("column"),
                                tl: {
                                    hd: Css.padding2("zero", {
                                        NAME: "px",
                                        VAL: 30
                                    }),
                                    tl: {
                                        hd: Css.selector("& > *", {
                                            hd: Css.margin2({
                                                NAME: "px",
                                                VAL: 10
                                            }, "zero"),
                                            tl: /* [] */ 0
                                        }),
                                        tl: /* [] */ 0
                                    }
                                }
                            }
                        }),
                        tl: /* [] */ 0
                    }
                }
            }
        })
    }, React.createElement("h2", undefined, ReactUtils$SmartcutsMacros.s("Forgot Password?")), React.createElement("p", undefined, ReactUtils$SmartcutsMacros.s("To reset your password, please enter the email address you used to register with Smartcuts. "), ReactUtils$SmartcutsMacros.s("We will send you an email with instructions to reset your password.")), React.createElement(Antd.Form, {
        children: null
    }, React.createElement(Antd_Input.make, {
        placeholder: "yourname@example.com",
        onChange: function($$event) {
            var target = $$event.target;
            return Curry._1(setState, function(state) {
                return {
                    email: target.value,
                    isRequestingForgotPassword: state.isRequestingForgotPassword
                };
            });
        }
    }), React.createElement(Antd.Button, {
        disabled: match$1.isRequestingForgotPassword || email === "",
        type: "primary",
        onClick: function(param) {
            Curry._1(setState, function(state) {
                return {
                    email: state.email,
                    isRequestingForgotPassword: true
                };
            });
            PromiseUtils$SmartcutsMacros.map(requestForgotPassword(email), function(param) {
                Antd.message.success(React.createElement(React.Fragment, undefined, ReactUtils$SmartcutsMacros.s("If you have registered with "), React.createElement("strong", undefined, ReactUtils$SmartcutsMacros.s(email)), ReactUtils$SmartcutsMacros.s(", you will receive an email. Please check your inbox.")), 3, undefined);
                return Curry._1(setState, function(state) {
                    return {
                        email: state.email,
                        isRequestingForgotPassword: false
                    };
                });
            });
        },
        children: ReactUtils$SmartcutsMacros.s("Send me an email")
    }))));
}
var make = PageForgotPassword;
__webpack_unused_export__ = requestForgotPassword;
exports.S = make; /* Css Not a pure module */ 


/***/ }),

/***/ 2908:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Generated by ReScript, PLEASE EDIT WITH CARE

var Css = __webpack_require__(62418);
var Curry = __webpack_require__(41386);
var React = __webpack_require__(67294);
var Link = (__webpack_require__(41664)["default"]);
var ReactUtils$SmartcutsMacros = __webpack_require__(80310);
var styles = {
    marginRight: "10px"
};
function Header(Props) {
    var home = Props.home;
    var onClickCallToAction = Props.onClickCallToAction;
    return React.createElement("header", {
        className: Curry._1(Css.style, {
            hd: Css.width({
                NAME: "percent",
                VAL: 100
            }),
            tl: {
                hd: Css.display("flex"),
                tl: {
                    hd: Css.alignItems("center"),
                    tl: {
                        hd: Css.justifyContent("spaceBetween"),
                        tl: {
                            hd: Css.height(Css.px(100)),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        })
    }, React.createElement("div", {
        className: Curry._1(Css.style, {
            hd: Css.display("flex"),
            tl: {
                hd: Css.flexDirection("row"),
                tl: {
                    hd: Css.justifyContent("spaceBetween"),
                    tl: {
                        hd: Css.width({
                            NAME: "percent",
                            VAL: 100
                        }),
                        tl: {
                            hd: Css.maxWidth(Css.px(1140)),
                            tl: {
                                hd: Css.marginLeft("auto"),
                                tl: {
                                    hd: Css.marginRight("auto"),
                                    tl: {
                                        hd: Css.alignItems("center"),
                                        tl: /* [] */ 0
                                    }
                                }
                            }
                        }
                    }
                }
            }
        })
    }, React.createElement("h1", {
        className: Curry._1(Css.style, {
            hd: Css.fontFamily({
                NAME: "custom",
                VAL: '"Helvetica Neue", Helvetica, Arial, sans-serif'
            }),
            tl: {
                hd: Css.margin("zero"),
                tl: {
                    hd: Css.color({
                        NAME: "hex",
                        VAL: "1A8FE6"
                    }),
                    tl: /* [] */ 0
                }
            }
        })
    }, home ? React.createElement(React.Fragment, undefined, React.createElement("img", {
        className: Curry._1(Css.style, {
            hd: Css.width(Css.px(40)),
            tl: {
                hd: Css.verticalAlign("middle"),
                tl: {
                    hd: Css.marginRight({
                        NAME: "px",
                        VAL: 10
                    }),
                    tl: /* [] */ 0
                }
            }
        }),
        src: "/img/logo66.png"
    }), React.createElement("span", {
        className: Curry._1(Css.style, {
            hd: Css.fontSize(Css.px(30)),
            tl: {
                hd: Css.fontWeight({
                    NAME: "num",
                    VAL: 400
                }),
                tl: {
                    hd: Css.media("(max-width: 414px)", {
                        hd: Css.fontSize(Css.px(20)),
                        tl: /* [] */ 0
                    }),
                    tl: /* [] */ 0
                }
            }
        })
    }, ReactUtils$SmartcutsMacros.s("smartcuts"))) : React.createElement(Link, {
        href: "/",
        children: React.createElement("a", {
            className: Curry._1(Css.style, {
                hd: Css.textDecoration("none"),
                tl: {
                    hd: Css.color({
                        NAME: "hex",
                        VAL: "1A8FE6"
                    }),
                    tl: /* [] */ 0
                }
            })
        }, React.createElement("img", {
            className: Curry._1(Css.style, {
                hd: Css.verticalAlign("middle"),
                tl: {
                    hd: Css.marginRight({
                        NAME: "px",
                        VAL: 20
                    }),
                    tl: /* [] */ 0
                }
            }),
            src: "/img/logo66.png"
        }), React.createElement("span", undefined, ReactUtils$SmartcutsMacros.s("smartcuts")))
    })), React.createElement("nav", {
        className: Curry._1(Css.style, {
            hd: Css.display("flex"),
            tl: {
                hd: Css.flexDirection("row"),
                tl: {
                    hd: Css.alignItems("center"),
                    tl: {
                        hd: Css.justifyContent("flexEnd"),
                        tl: {
                            hd: Css.flexGrow(1),
                            tl: {
                                hd: Css.flexShrink(1),
                                tl: {
                                    hd: Css.flexBasis({
                                        NAME: "percent",
                                        VAL: 1
                                    }),
                                    tl: {
                                        hd: Css.media("(max-width: 414px)", {
                                            hd: Css.display("none"),
                                            tl: /* [] */ 0
                                        }),
                                        tl: /* [] */ 0
                                    }
                                }
                            }
                        }
                    }
                }
            }
        })
    }, React.createElement(Link, {
        href: "/login",
        children: React.createElement("a", {
            className: Curry._1(Css.style, {
                hd: Css.fontFamily({
                    NAME: "custom",
                    VAL: '"Helvetica Neue", Helvetica, Arial, sans-serif'
                }),
                tl: {
                    hd: Css.color({
                        NAME: "hex",
                        VAL: "1A8FE6"
                    }),
                    tl: {
                        hd: Css.textDecoration("none"),
                        tl: {
                            hd: Css.fontSize({
                                NAME: "px",
                                VAL: 20
                            }),
                            tl: {
                                hd: Css.marginRight(Css.px(24)),
                                tl: /* [] */ 0
                            }
                        }
                    }
                }
            })
        }, ReactUtils$SmartcutsMacros.s("Login"))
    })), React.createElement("button", {
        className: Curry._1(Css.style, {
            hd: Css.backgroundColor({
                NAME: "hex",
                VAL: "fd6f2f"
            }),
            tl: {
                hd: Css.color({
                    NAME: "hex",
                    VAL: "fff"
                }),
                tl: {
                    hd: Css.borderRadius(Css.px(3)),
                    tl: {
                        hd: Css.padding2(Css.px(8), Css.px(20)),
                        tl: {
                            hd: Css.fontWeight({
                                NAME: "num",
                                VAL: 600
                            }),
                            tl: {
                                hd: Css.textTransform("uppercase"),
                                tl: {
                                    hd: Css.cursor("pointer"),
                                    tl: {
                                        hd: Css.borderStyle("none"),
                                        tl: {
                                            hd: Css.height(Css.px(40)),
                                            tl: {
                                                hd: Css.media("(max-width: 414px)", {
                                                    hd: Css.fontSize(Css.px(12)),
                                                    tl: /* [] */ 0
                                                }),
                                                tl: /* [] */ 0
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }),
        onClick: function(_event) {
            return Curry._1(onClickCallToAction, undefined);
        }
    }, ReactUtils$SmartcutsMacros.s("Request "), React.createElement("span", {
        className: Curry._1(Css.style, {
            hd: Css.media("(max-width: 414px)", {
                hd: Css.display("none"),
                tl: /* [] */ 0
            }),
            tl: /* [] */ 0
        })
    }, ReactUtils$SmartcutsMacros.s("Early ")), ReactUtils$SmartcutsMacros.s("Access"))));
}
var make = Header;
exports.styles = styles;
exports.make = make; /* Css Not a pure module */ 


/***/ }),

/***/ 64056:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Generated by ReScript, PLEASE EDIT WITH CARE

var Css = __webpack_require__(62418);
var Curry = __webpack_require__(41386);
var React = __webpack_require__(67294);
var Head = (__webpack_require__(9008)["default"]);
var Header$SmartcutsMacros = __webpack_require__(2908);
var ReactUtils$SmartcutsMacros = __webpack_require__(80310);
function LayoutPublic(Props) {
    var homeOpt = Props.home;
    var onClickCallToAction = Props.onClickCallToAction;
    var children = Props.children;
    var home = homeOpt !== undefined ? homeOpt : false;
    return React.createElement(React.Fragment, undefined, React.createElement(Head, {
        children: null
    }, React.createElement("link", {
        href: "/favicon-16.png",
        rel: "icon",
        sizes: "16x16",
        type: "image/png"
    }), React.createElement("link", {
        href: "/favicon-32.png",
        rel: "icon",
        sizes: "32x32",
        type: "image/png"
    }), React.createElement("link", {
        href: "/favicon-96.png",
        rel: "icon",
        sizes: "96x96",
        type: "image/png"
    })), React.createElement(Header$SmartcutsMacros.make, {
        home: home,
        onClickCallToAction: onClickCallToAction
    }), React.createElement("div", {
        className: Curry._1(Css.style, {
            hd: Css.display("flex"),
            tl: {
                hd: Css.flexDirection("column"),
                tl: {
                    hd: Css.minHeight({
                        NAME: "vh",
                        VAL: 80.0
                    }),
                    tl: {
                        hd: Css.fontFamily({
                            NAME: "custom",
                            VAL: '"Helvetica Neue", Helvetica, Arial, sans-serif'
                        }),
                        tl: {
                            hd: Css.alignItems("center"),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        })
    }, children), React.createElement("footer", {
        className: Curry._1(Css.style, {
            hd: Css.display("flex"),
            tl: {
                hd: Css.alignItems("center"),
                tl: {
                    hd: Css.justifyContent("spaceAround"),
                    tl: {
                        hd: Css.flexWrap("wrap"),
                        tl: {
                            hd: Css.fontFamily({
                                NAME: "custom",
                                VAL: '"Helvetica Neue", Helvetica, Arial, sans-serif'
                            }),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        })
    }, React.createElement("div", {
        className: Curry._1(Css.style, {
            hd: Css.color(Css.hex("acacae")),
            tl: {
                hd: Css.fontSize({
                    NAME: "px",
                    VAL: 12
                }),
                tl: {
                    hd: Css.selector("& > a", {
                        hd: Css.color(Css.hex("acacae")),
                        tl: /* [] */ 0
                    }),
                    tl: /* [] */ 0
                }
            }
        })
    }, ReactUtils$SmartcutsMacros.s("2021 \xa9 Smartcuts"), ReactUtils$SmartcutsMacros.s(" | "), React.createElement("a", {
        href: "/privacy_policy.html",
        target: "_blank"
    }, ReactUtils$SmartcutsMacros.s("Privacy policy")), ReactUtils$SmartcutsMacros.s(" | "), React.createElement("a", {
        href: "/terms_of_service.html",
        target: "_blank"
    }, ReactUtils$SmartcutsMacros.s("Terms of service")), ReactUtils$SmartcutsMacros.s(" | "), React.createElement("a", {
        href: "/cookie_policy.html",
        target: "_blank"
    }, ReactUtils$SmartcutsMacros.s("Cookie policy")))));
}
var make = LayoutPublic;
exports.make = make; /* Css Not a pure module */ 


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(83121)


/***/ }),

/***/ 69852:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Webapi__Dom__Event = __webpack_require__(71451);

var include = Webapi__Dom__Event.Impl({});

var eventPhase = include.eventPhase;

exports.eventPhase = eventPhase;
/* include Not a pure module */


/***/ }),

/***/ 39575:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Webapi__Dom__Event = __webpack_require__(71451);
var Webapi__Dom__UiEvent = __webpack_require__(91208);
var Webapi__Dom__MouseEvent = __webpack_require__(49116);

var include = Webapi__Dom__Event.Impl({});

Webapi__Dom__UiEvent.Impl({});

var include$1 = Webapi__Dom__MouseEvent.Impl({});

var eventPhase = include.eventPhase;

var getModifierState = include$1.getModifierState;

exports.eventPhase = eventPhase;
exports.getModifierState = getModifierState;
/* include Not a pure module */


/***/ }),

/***/ 63056:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Webapi__Dom__Event = __webpack_require__(71451);
var Webapi__Dom__UiEvent = __webpack_require__(91208);

var include = Webapi__Dom__Event.Impl({});

Webapi__Dom__UiEvent.Impl({});

var eventPhase = include.eventPhase;

exports.eventPhase = eventPhase;
/* include Not a pure module */


/***/ }),

/***/ 82371:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Webapi__Dom__Event = __webpack_require__(71451);
var Webapi__Dom__UiEvent = __webpack_require__(91208);

var include = Webapi__Dom__Event.Impl({});

Webapi__Dom__UiEvent.Impl({});

var eventPhase = include.eventPhase;

exports.eventPhase = eventPhase;
/* include Not a pure module */


/***/ }),

/***/ 41702:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Webapi__Dom__Event = __webpack_require__(71451);
var Webapi__Dom__Types = __webpack_require__(97088);
var Webapi__Dom__UiEvent = __webpack_require__(91208);

var include = Webapi__Dom__Event.Impl({});

Webapi__Dom__UiEvent.Impl({});

function getModifierState(self, key) {
  return self.getModifierState(Webapi__Dom__Types.encodeModifierKey(key));
}

var eventPhase = include.eventPhase;

exports.eventPhase = eventPhase;
exports.getModifierState = getModifierState;
/* include Not a pure module */


/***/ }),

/***/ 49116:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Webapi__Dom__Event = __webpack_require__(71451);
var Webapi__Dom__Types = __webpack_require__(97088);
var Webapi__Dom__UiEvent = __webpack_require__(91208);

function Impl(T) {
  var getModifierState = function (self, key) {
    return self.getModifierState(Webapi__Dom__Types.encodeModifierKey(key));
  };
  return {
          getModifierState: getModifierState
        };
}

var include = Webapi__Dom__Event.Impl({});

Webapi__Dom__UiEvent.Impl({});

function getModifierState(self, key) {
  return self.getModifierState(Webapi__Dom__Types.encodeModifierKey(key));
}

var eventPhase = include.eventPhase;

exports.Impl = Impl;
exports.eventPhase = eventPhase;
exports.getModifierState = getModifierState;
/* include Not a pure module */


/***/ }),

/***/ 91208:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Webapi__Dom__Event = __webpack_require__(71451);

function Impl(T) {
  return {};
}

var include = Webapi__Dom__Event.Impl({});

var eventPhase = include.eventPhase;

exports.Impl = Impl;
exports.eventPhase = eventPhase;
/* include Not a pure module */


/***/ }),

/***/ 53329:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Webapi__Dom__Event = __webpack_require__(71451);
var Webapi__Dom__Types = __webpack_require__(97088);
var Webapi__Dom__UiEvent = __webpack_require__(91208);
var Webapi__Dom__MouseEvent = __webpack_require__(49116);

var include = Webapi__Dom__Event.Impl({});

Webapi__Dom__UiEvent.Impl({});

var include$1 = Webapi__Dom__MouseEvent.Impl({});

function deltaMode(self) {
  return Webapi__Dom__Types.decodeDeltaMode(self.deltaMode);
}

var eventPhase = include.eventPhase;

var getModifierState = include$1.getModifierState;

exports.eventPhase = eventPhase;
exports.getModifierState = getModifierState;
exports.deltaMode = deltaMode;
/* include Not a pure module */


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,4951,9525,7072,2380,4797,7025,6513,1664,9359,310,2567,2349,5418,5129,3661,9003,1166,545,2888,9774,179], function() { return __webpack_exec__(25436), __webpack_exec__(57982); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);